@if (questions[currentStep].questions.length > 0) {
  <fieldset class="mb-6 p-4">
    <legend class="text-base font-semibold mb-2 text-gray-800">
      {{ questions[currentStep].title }}
    </legend>

    <div class="flex flex-col gap-3">
      @for (q of questions[currentStep].questions; track q.id) {

        @if (q.type === 'radio') {
          <div class="flex flex-col">
            
            <span class="text-sm text-gray-700 mb-1">
              {{ q.label }}
            </span>

            <div class="flex flex-col gap-2">

              @for (opt of q.options; track opt) {
                <div class="flex items-center gap-3 text-sm text-gray-700">

                  <input
                    type="radio"
                    [(ngModel)]="q.value"
                    [value]="opt"
                    [name]="q.id"
                    [id]="q.id + '-' + opt"
                    class="form-radio h-4 w-4 text-blue-600"
                  />

                  <label [for]="q.id + '-' + opt">
                    {{ opt }}
                  </label>

                </div>
              }

            </div>
          </div>
        }

      }
    </div>
  </fieldset>
}